import React from 'react'
import styled from 'styled-components'

const color = props => (props?.removingItem ? '#7E7E84' : '#333')

const StyledButton = styled.button`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  text-decoration-line: underline;
  padding: 0;
  border: 0;
  margin: 0;
  background: white;
  color: ${color};
  cursor: pointer;
  align-self: end;
`

const RemoveFromCartWmo = ({ handleAction, index, removingItem }) => (
  <StyledButton
    index={index}
    id={`deleteItem${index}`}
    onClick={handleAction}
    disabled={removingItem}
    removingItem={removingItem}
  >
    { removingItem ? 'Removing...' : 'Remove'}

  </StyledButton>
)

export default RemoveFromCartWmo
